import { createStore } from './store-factory';

interface ExperimentalModeState {
  experimentalModeEnabled: boolean;
  setExperimentalModeEnabled: (enabled: boolean) => void;
  toggleExperimentalMode: () => void;
}

export const useExperimentalModeStore = createStore<ExperimentalModeState>(
  'experimental-mode',
  (set, get) => ({
    experimentalModeEnabled: false,
    
    setExperimentalModeEnabled: (enabled: boolean) => {
      set({ experimentalModeEnabled: enabled });
    },
    
    toggleExperimentalMode: () => {
      const { experimentalModeEnabled } = get();
      set({ experimentalModeEnabled: !experimentalModeEnabled });
    },
  }),
  {
    persist: true,
    persistFields: ['experimentalModeEnabled'],
  }
);